export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 180,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('INDEX.form_label_orderNo') || '订单编号',
    field: 'orderNo',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_orderStatus') || '订单状态',
    width: 100,
    align: 'center',
    slots: { default: 'status' }
  },
  {
    title: that.$l('INDEX.form_label_salesPersonCode') || '业务人员名字',
    field: 'salesPersonName',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_bizPersonCode') || '跟单人员',
    field: 'bizPersonName',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_customerComfirmTime') || '客户下单日期',
    field: 'customerComfirmTime',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_deliveryDay') || '交货日期',
    field: 'deliveryDay',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_custCode') || '下单客户',
    field: 'custName',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_endCustCode') || '终端客户',
    field: 'endCustName',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_orderType') || '订单类型',
    field: 'v_orderType',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_quotedMethod') || '报价方式',
    field: 'v_quotedMethod',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_Total_order_cost') || '订单成本总价',
    field: 'orderAmount',
    minWidth: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    slots: { default: 'orderAmountInfo' }
  },
  {
    title:
      that.$l('INDEX.form_label_Total_order_selling_price') || '订单售价合计',
    field: 'orderSalesAmount',
    minWidth: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    slots: { default: 'orderSalesAmountInfo' }
  },
  {
    title: that.$l('INDEX.form_label_orderSource') || '订单来源',
    field: 'v_orderSource',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_orderExecuteType') || '执行方式',
    field: 'v_orderExecuteType',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_scmCode') || '执行工厂',
    field: 'scmName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_orderScmCode') || '名义工厂',
    field: 'orderScmCodeName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_settlementFactory') || '结算工厂',
    field: 'settlementFactoryName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_identifyNo') || '识别单号',
    field: 'identifyNo',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_productLine') || '产品线',
    field: 'v_productLine',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_salesSeason') || '销售季节',
    field: 'v_salesSeason',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_importanceLevel') || '重要级别',
    field: 'v_importanceLevel',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.form_label_submitInfo') || '提交信息',
    field: 'submitByName',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'submitInfo' }
  },
  {
    title: that.$l('INDEX.form_label_reviewInfo') || '审核人',
    field: 'reviewByName',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'reviewInfo' }
  },
  {
    title: that.$l('INDEX.creator') || '创建人',
    field: 'createByName',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' }
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' }
  }
]
